export default class NameTeam
{
    constructor(instructions, basic_info){
        this.instructions       = instructions
        this.basic_info     = basic_info
    }

    toFormData(){
        let fData = new FormData()
        
        // معلومات رئيس المنظمة
        fData.append('name1', this.basic_info.name1);
        fData.append('name2', this.basic_info.name2);
        fData.append('name3', this.basic_info.name3);
        fData.append('name4', this.basic_info.name4);
        fData.append('family_name', this.basic_info.family_name);
        fData.append('phone', this.basic_info.phone);
        fData.append('city_id', this.basic_info.city_id);
        fData.append('district', this.basic_info.district);
        fData.append('facebook', this.basic_info.facebook);
        fData.append('instagram', this.basic_info.instagram);
        
        // معلومات المنظمة او الفريق
        fData.append('organization_name1', this.basic_info.team_name1);
        fData.append('organization_name2', this.basic_info.team_name2);
        fData.append('organization_name3', this.basic_info.team_name3);

        fData.append('organization_name1_en', this.basic_info.team_name_eng1);
        fData.append('organization_name2_en', this.basic_info.team_name_eng2);
        fData.append('organization_name3_en', this.basic_info.team_name_eng3);

        fData.append('organization_type_id', this.basic_info.team_organizationtype_id);
        if(this.basic_info.team_organizationtype_id == '21'){
            fData.append('another_organization', this.basic_info.team_other_org);
        }
        fData.append('organization_phone', this.basic_info.team_phone);
        if(this.basic_info.team_gmail != null){
            fData.append('organization_email', this.basic_info.team_gmail);
        }
        fData.append('organization_facebook', this.basic_info.team_facebook);
        fData.append('organization_instagram', this.basic_info.team_instagram);

        return fData
    }
}

